export default {
  setGenerateReportLoading(state, loading) {
    state.generateReportLoading = loading
  },
}
